<template>
  <a-button @click="showAddModal">{{ $t("add") }}</a-button>
  <a-modal  style="top: 20px"
            v-model:visible="visible"
            :title="$t('add')"
            @ok="handleOk"
            :okText="$t('submit')"
            :cancelText="$t('cancel')"
  >
    <a-form
        ref="userForm"
        :model="visit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
    >
      <a-form-item ref="userid" :label="$t('user.name')"
                   :rules="[{ required: true, message: $t('pleaseSelect') + $t('user.name') }]"
                   name="userid">
        <select-id-and-name v-model:value="visit.userid" :list="userList" option-text="name" option-value="id"></select-id-and-name>
      </a-form-item>
      <a-form-item ref="phone" :label="$t('phone')" name="phone">
        <a-input v-model:value="visit.phone" />
      </a-form-item>
      <a-form-item ref="usertype" :label="$t('user.usertype')" name="usertype">
        <a-select v-model:value="visit.usertype" mode="multiple">
          <a-select-option value="00">{{ $t("user.normalUser") }}</a-select-option>
          <a-select-option value="01">{{ $t("user.labAdmin") }}</a-select-option>
          <a-select-option value="02">{{ $t("user.PI") }}</a-select-option>
          <a-select-option value="99">{{ $t("user.adminUser") }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/16 10:29
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import SelectIdAndName from "@/components/public/selectIdAndName";

export default {
  name: "addNewUser",
  components: {SelectIdAndName, VLoading},
  data() {
    return {
      loading: false,
      visible : false,
      visit : {},
      userList : []
    }
  },
  mounted() {
  },
  methods: {
    handleOk(){
      this.$refs.userForm.validate().then(() => {
        var post = {
          visit : JSON.stringify(this.visit)
        }
        util.$post("/admin/user/add/submit", post, () => {
          this.visible = false;
          util.submitSuccess();
          this.$emit("createSuccess")
        }, this.showMask, this.hideMask);
      })
    },
    showAddModal(){
      this.visible = true;
      this.initPage();
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {}
      util.$post("/admin/user/add/init", post, (res) => {
        this.userList = res.userList;
      }, this.showMask, this.hideMask);
    }
  }
}
</script>

<style scoped>

</style>